import { Compass, UserRoundCheck, ShieldCheck, MessagesSquare, FolderKanban, Inbox, FileText, UserRound } from "lucide-react";

export const OPPORTUNITIES = [
    {
        n: "P.01",
        icon: Compass,
        title: "DISCOVER RELEVANT PROJECTS",
        copy: "See residential work that fits your trade, region and capacity.",
    },
    {
        n: "P.02",
        icon: UserRoundCheck,
        title: "PRESENT YOUR EXPERTISE",
        copy: "Show your category, services and experience in plain language.",
    },
    {
        n: "P.03",
        icon: ShieldCheck,
        title: "BUILD CREDIBILITY",
        copy: "A professional profile homeowners can check before they contact you.",
    },
    {
        n: "P.04",
        icon: MessagesSquare,
        title: "COMMUNICATE WITH HOMEOWNERS",
        copy: "Clear, project-based conversations in one place.",
    },
    {
        n: "P.05",
        icon: FolderKanban,
        title: "WORK WITHIN PROJECT WORKSPACES",
        copy: "Keep plans, pricing and decisions organised per project.",
    },
    {
        n: "P.06",
        icon: Inbox,
        title: "RECEIVE RELEVANT OPPORTUNITIES",
        copy: "Be notified of residential work that matches your context.",
    },
];

export const PROFESSIONAL_TYPES = [
    "CONTRACTORS",
    "QUANTITY SURVEYORS",
    "ARCHITECTS",
    "ENGINEERS",
    "PROJECT MANAGERS",
    "SPECIALISTS",
];

export const MATCH_PROJECT = "Durban residential build";

export const MATCH_CONTEXT = [
    "Residential construction",
    "KwaZulu-Natal",
    "Relevant project experience",
    "Professional category",
    "Services offered",
];

export const WORKSPACE_NAV = [
    { icon: FolderKanban, label: "PROJECTS", active: true },
    { icon: MessagesSquare, label: "MESSAGES", active: false },
    { icon: FileText, label: "DOCUMENTS", active: false },
    { icon: Inbox, label: "OPPORTUNITIES", active: false },
    { icon: UserRound, label: "PROFILE", active: false },
];

export const WORKSPACE_PROJECTS = [
    {
        name: "Residential Build",
        location: "Durban, KwaZulu-Natal",
        stage: "PRICE",
        accent: true,
    },
    {
        name: "Residential Alteration",
        location: "Cape Town, Western Cape",
        stage: "PLAN",
        accent: false,
    },
    {
        name: "New Home",
        location: "Johannesburg, Gauteng",
        stage: "BUILD",
        accent: false,
    },
];
